// In-line destructuring syntax in an import statement when using ES Modules spec:
// 1) declaring a variable with the name in the { } - object desstructuring - so that if that name in the { } matches the name of a prop on the object it is pointing at (i.e. the namespace object on the file path we include after the from key word!) - we will succesfully hook into object literals short hand syntax in javascript 
// 2) and assign the value of that newly declared variable to be the value of the eponymously named property on the object it is pointing atimport { useAPI } from './useAPI.js';
import { useDashBaseAPI } from "./api/clients/useBaseAPI.js";

export const useSubscriptionAPI = () => {
  const subscription = useDashBaseAPI("/subscription");

  const getSubscriptionsProxy = async () => {
    const response = await subscription.get("/stripe/subscriptions")
    console.log("[SUCCESS] Response from stripe subscriptions proxy endpoint: ", response)
    return response;
  }

    const getPaymentMethodsProxy = async () => {
    const response = await subscription.get("/stripe/payment-methods")
    console.log("[SUCCESS] Response from stripe payment methods proxy endpoint: ", response)
    return response;
  }
  
  const getCheckoutSessionURL = async () => {
    const response = await subscription.get("/checkout-session");
    console.log("[SUCCESS] Response from subscription checkout session endpoint: ", response)
    return response;
  };
  
  const getCancelSessionURL = async () => {
    const response = await subscription.get("/cancel-session");
    return response;
  };
  
  return {
    getSubscriptionsProxy,
    getPaymentMethodsProxy,
    getCheckoutSessionURL,
    getCancelSessionURL
  };
};